import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import CallHistoryContent from '../components/pages/waiting-area/view-history/content';

const CallHistoryContentContainer = (props) => {
  const videoCallRoomSelected = useSelector((state) => state.waitingAreaReducer.waitingAreaCallHistory);

  const dispatch = useDispatch();

  return (
    <CallHistoryContent
      showCallHistoryModal={props.showCallHistoryModal}
      timezone={props.timezone}
      videoCallRoomSelected={videoCallRoomSelected}
      dispatch={dispatch}
    />
  );
};

export default CallHistoryContentContainer;
